// Copyright (c) 2017 Deere & Company

import File, {getDefaultState as getDefaultFileState} from './file';
import AuditResult from './audit-result';
import t from 'tcomb';

const AuditSummary = t.struct({
    account: t.maybe(t.String),
    actualAuditDate: t.maybe(t.Number),
    auditNumber: t.maybe(t.String),
    auditPlannedDate: t.maybe(t.Number),
    auditResults: t.list(AuditResult, 'AuditResults'),
    auditType: t.maybe(t.String),
    auditTypeDescription: t.maybe(t.String),
    city: t.maybe(t.String),
    claimNumber: t.maybe(t.String),
    claimType: t.maybe(t.String),
    completedBy: t.maybe(t.String),
    creditMemo: t.maybe(t.String),
    creditMemoSelected: t.maybe(t.String),
    customerName: t.maybe(t.String),
    debitAmount: t.maybe(t.String),
    debitRequestStatus: t.maybe(t.String),
    debitRequired: t.maybe(t.String),
    debitRequiredDescription: t.maybe(t.String),
    file: File,
    fiscalYear: t.maybe(t.String),
    leadAccount: t.maybe(t.String),
    pin: t.maybe(t.String),
    plannedBy: t.maybe(t.String),
    reasonForAudit: t.maybe(t.String),
    reasonForDebit: t.maybe(t.String),
    reference2: t.maybe(t.String),
    state: t.maybe(t.String),
    territory: t.maybe(t.String),
    workRepairOrder: t.maybe(t.String)
}, {
    name: 'AuditSummary',
    strict: true
});

export const getDefaultState = () => new AuditSummary({
    account: '',
    actualAuditDate: null,
    auditNumber: '',
    auditPlannedDate: null,
    auditResults: [],
    auditType: '',
    auditTypeDescription: '',
    city: '',
    claimNumber: '',
    claimType: '',
    completedBy: null,
    creditMemo: '',
    creditMemoSelected: '',
    customerName: '',
    debitAmount: '',
    debitRequestStatus: '',
    debitRequired: '',
    debitRequiredDescription: '',
    file: getDefaultFileState(),
    fiscalYear: '',
    leadAccount: '',
    pin: '',
    plannedBy: '',
    reasonForAudit: '',
    reasonForDebit: '',
    reference2: '',
    state: '',
    territory: '',
    workRepairOrder: ''
});

export default AuditSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-summary.js